import { AxiosResponse } from 'axios'
import { ApiPermissionsConfigurationViewModel } from '../api'
import { useApiClient } from './useApiClient'

export const usePermissionsApi = () => {
  const apiClient = useApiClient()

  const getPermissionsAndScopes = () => {
    return apiClient.request<
      void,
      AxiosResponse<ApiPermissionsConfigurationViewModel>
    >({
      url: `api/supportUsers/permissions`,
      method: 'get',
      withCredentials: true,
    })
  }

  return {
    getPermissionsAndScopes,
  }
}
